export default "__VITE_ASSET__BRFctdKK__"